import { useMutation } from "@apollo/client";
import { READ_ALL_NOTIFICATIONS } from "@/modules/common/widgets/notification-bell/api/read-all-notifications";
import { GET_PERSON_NOTIFICATIONS } from "@/modules/common/widgets/notification-bell/api/get-person-notifications";

export function useReadAllNotificationsMutation() {
  const [readAll, { loading }] = useMutation(READ_ALL_NOTIFICATIONS, {
    refetchQueries: [GET_PERSON_NOTIFICATIONS],
  });

  return {
    readAll,
    loading,
  };
}
